<template>
  <div>
    <b-skeleton-wrapper :loading="loading" class="d-md-none">
      <template #loading>
        <p>
          <b-skeleton></b-skeleton>
          <b-skeleton width="25%"></b-skeleton>
          <b-skeleton></b-skeleton>
        </p>
        <p>
          <b-skeleton></b-skeleton>
          <b-skeleton width="35%"></b-skeleton>
          <b-skeleton></b-skeleton>
        </p>
        <p>
          <b-skeleton></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton></b-skeleton>
        </p>
        <p>
          <b-skeleton></b-skeleton>
          <b-skeleton width="65%"></b-skeleton>
          <b-skeleton></b-skeleton>
        </p>
      </template>
      <div v-if="transactions.length > 0" class="d-md-none">
        <div
          class="rounded border d-block d-md-none"
          v-for="(item,index) in transactions"
          :key="index"
          @click.prevent="hasRoute ? goTo(item.id) : ''"
        >
          <!-- <h5 class="text-left font-weight-bold mb-3 ml-2 mt-3">
            {{getOtherDay(item.created_at)}}
          </h5> -->

          <div
            class="px-2 py-3 border-bottom d-flex justify-content-between"
          >
            <div class="d-flex align-items-center">
              <i class="fa fa-paper-plane p-3 rounded-circle bg-primary text-white reflect-rotate"></i>
              <div class="text-left ml-2">
                <p class="mb-1 font-weight-bold">{{item.name}}</p>
              </div>
            </div>
            <div class="text-right">
              <p class="mb-1 font-weight-bold text-success">{{ item.text }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="filteredTransactions.length <= 0 && (search == null || search == '')"><empty-table class="d-md-none"></empty-table></div>
      <div v-if="filteredTransactions.length <= 0 && search != null && search != ''" class="p-5">
        Your search " <span class="font-weight-bold">{{search}}</span> " did not match any of transactions
      </div>
    </b-skeleton-wrapper>
  </div>
</template>
<script>
import moment from 'moment';
import EmptyTable from '../utils/empty-table.vue';
import StatusButton from './StatusButton.vue';

export default {
  components: {
    EmptyTable,
    StatusButton
  },
  props: {
    transactions: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    limit: {
      type: Number,
      required: false
    },
    type: {
      type: String,
      required: false
    },
    hasRoute: {
      type: Boolean,
      required: false
    },
    routerLink: {
      type: String,
      required: false
    },
    filter: {
      type: Object,
      required: false
    },
    search: {
      type: String,
      required: false
    }
  },
  mounted () {
  },
  computed: {
    numberOfTransactions () {
      const limit = this.transactions;
      limit.splice(this.limit);
      let newArray = limit;
      let newFilter = {};
      if (this.filter && this.filter !== 'undefined') {
        newFilter = this.filter;

        // check if the Object filter is not null, '!' negate the result
        let result = !Object.values(newFilter).every(o => o === null);
        if (result) {
          if (newFilter.filters.payerQuery) {
            newArray = newArray.filter((item) => this.type == 'settlements' ? item.account.name : item.payer_account.name == newFilter.filters.payerQuery)
          }
          if (newFilter.filters.numberFilter) {
            newArray = newArray.filter((item) => (this.type == 'settlements' ? item.short_id.search(newFilter.filters.numberFilter) : item.service_reference.search(newFilter.filters.numberFilter)) !== -1)
          }
          if (newFilter.filters.startDate) {
            newArray = newArray.filter((item) => moment(item.created_at).format('L') >= moment(newFilter.filters.startDate).format('L'))
          }
          if (newFilter.filters.endDate) {
            newArray = newArray.filter((item) => moment(item.created_at).format('L') <= moment(newFilter.filters.endDate).format('L'))
          }
        }
      }

      // if 'search' is being called
      if (this.search) {
        if (this.search !== null && this.search !== '' && this.type == 'settlements') {
          
          newArray = newArray.filter(
            (item) =>
            item.account.name.toLowerCase().search(this.search) !== -1 ||
            item.short_id.search(this.search) !== -1
          )
        } else {
          newArray = newArray.filter(
            (item) =>
            item.payer_account.name.toLowerCase().search(this.search) !== -1 ||
            item.service_reference.search(this.search) !== -1 ||
            item.short_id.search(this.search) !== -1
          )
        }
      }
      return newArray;
    },
    filteredTransactions() {
      let objectCheck = !Object.values(this.filter).every(o => o === null);
      if ( objectCheck || this.search) {
        return this.numberOfTransactions;
      } else {
        return this.transactions;
      }
    }
  },
  methods: {
    goTo (id) {
      this.$router.push(this.routerLink + id);
    },
  }
}
</script>
